export { default } from 'ember-cli-flash/components/flash-message';
